// Săgețile benzii de categorii din antet.
//
// Banda se derulează pe orizontală, dar bara de defilare e ascunsă: pe Windows
// arată a element de sistem. Săgețile apar doar când chiar e unde derula, ca să
// nu stea două butoane inerte peste categorii.
(function () {
  'use strict';

  function init(nav) {
    var list = nav.querySelector('.trove-scroll-cats__list');
    var prev = nav.querySelector('.trove-scroll-cats__arrow--prev');
    var next = nav.querySelector('.trove-scroll-cats__arrow--next');
    if (!list || !prev || !next) return;
    if (list.getAttribute('data-arrows-init')) return;
    list.setAttribute('data-arrows-init', '1');

    function update() {
      var max = list.scrollWidth - list.clientWidth;
      // Sub un prag de 2px nu e derulare reală, ci rotunjire de subpixel.
      if (max < 2) { prev.hidden = true; next.hidden = true; return; }
      prev.hidden = list.scrollLeft <= 1;
      next.hidden = list.scrollLeft >= max - 1;
    }

    function step(direction) {
      list.scrollBy({ left: direction * Math.round(list.clientWidth * 0.8), behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // Lățimile se schimbă după ce intră fonturile și imaginile categoriilor.
    window.addEventListener('load', update);

    update();
  }

  function boot() {
    var navs = document.querySelectorAll('.trove-scroll-cats');
    Array.prototype.forEach.call(navs, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
